export enum WeeklyDatepickerDataHooks {
  Main = 'weekly-date-picker-container',
  WeeklyDatepicker = 'weekly-date-picker',
}
